import { Handle, Position, HandleType } from 'reactflow';

export function HiddenHandle(args: { id?: string; position: Position; type: HandleType }) {
	return <Handle {...args} style={{ visibility: 'hidden' }} isConnectable={false} />;
}
